
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import T from '../../lang';
import omegaup_Markdown from '../Markdown.vue';
import omegaup_ToggleSwitch from '../ToggleSwitch.vue';
import Clipboard from 'v-clipboard';
import {
  FontAwesomeIcon,
  FontAwesomeLayers,
  FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
library.add(fas);
Vue.use(Clipboard);

export enum AdmissionMode {
  Private = 'private',
  Registration = 'registration',
  Public = 'public',
}

@Component({
  components: {
    'omegaup-markdown': omegaup_Markdown,
    'omegaup-toggle-switch': omegaup_ToggleSwitch,
    'font-awesome-icon': FontAwesomeIcon,
    'font-awesome-layers': FontAwesomeLayers,
    'font-awesome-layers-text': FontAwesomeLayersText,
  },
})
export default class ContestEditPublish extends Vue {
  @Prop() admissionMode!: AdmissionMode;
  @Prop() admissionModeDescription!: string;
  @Prop() alias!: string;
  @Prop() shouldShowPublicOption!: boolean;
  @Prop({ default: false }) defaultShowAllContestantsInScoreboard!: boolean;

  T = T;
  AdmissionMode = AdmissionMode;
  currentAdmissionMode = this.admissionMode;
  currentDefaultShowAllContestantsInScoreboard = this
    .defaultShowAllContestantsInScoreboard;

  get contestURL(): string {
    return `${window.location.origin}/arena/${this.alias}/startfresh/`;
  }

  onSubmit(): void {
    this.$emit('update-admission-mode', {
      admissionMode: this.currentAdmissionMode,
      defaultShowAllContestantsInScoreboard: this
        .currentDefaultShowAllContestantsInScoreboard,
    });
  }

  onCopyContestLink(): void {
    this.$emit('show-copy-message');
  }

  @Watch('admissionMode')
  onCourseChange(newValue: AdmissionMode): void {
    this.currentAdmissionMode = newValue;
  }
}
